var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueDecor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.9947 80.4658H79.0059V160.5H80.9947V80.4658Z",
    fill: "#919EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8971 79.5796H0V81.5566H79.8971V79.5796Z",
    fill: "#919EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1783 123.414L37.1719 118.438L77.4976 78.0117L82.5041 82.9883L42.1783 123.414Z",
    fill: "#004669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7193 81.1475L79.3477 79.7841L119.399 39.5625L120.771 40.9941L80.7193 81.1475Z",
    fill: "#919EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.001 84.0109H76.4688V0.5H83.5326V76.9891H160.001V84.0109Z",
    fill: "#004669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDecor);
export default __webpack_public_path__ + "static/media/blue-decor.8109b53c03b2c0fddb9cb1d2e47a8b2d.svg";
export { ForwardRef as ReactComponent };